import {RemoteDeleteBeneficiaryAddressV4} from 'data/usecases';
import {DeleteBeneficiaryAddressV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeDeleteBeneficiaryAddressV4 = (sequence: number): DeleteBeneficiaryAddressV4 =>
	new RemoteDeleteBeneficiaryAddressV4(
		makeBFFApiUrl(`${ProfileChangeDataEndpoints.beneficiaryAddressV4}/${sequence}`),
		makeAuthorizeHttpClientDecorator(),
	);
